const studentData = [
  {
    name: "Evelyn",
    task: "SCRUM",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W1D1-1",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Evelyn",
    task: "W1D2-1",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Evelyn",
    task: "W1D2-2",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W1D2-3",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Evelyn",
    task: "W1D2-4",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W1D2-5",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W1D3-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W1D3-2",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W1D3-4",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W1D3-5",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W1D3-P",
    difficulty: 5,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W1D4-1",
    difficulty: 4,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W1D4-P",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W1D5-P",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Evelyn",
    task: "W2D1-1",
    difficulty: 1,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W2D1-2",
    difficulty: 2,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W2D2-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W2D2-2",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W2D2-3",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W2D3-1",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W2D3-2",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Evelyn",
    task: "W2D3-3",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W2D4-1",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Evelyn",
    task: "W2D4-2",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W2D4-3",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Evelyn",
    task: "W2D5-P",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W3D1-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W3D1-2",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W3D1-3",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W3D1-4",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Evelyn",
    task: "W3D2-1",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W3D2-2",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Evelyn",
    task: "W3D2-3",
    difficulty: 3,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W3D3-1",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W3D3-2",
    difficulty: 4,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W3D3-3",
    difficulty: 3,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W3D3-4",
    difficulty: 4,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W3D4-1",
    difficulty: 5,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W3D4-2",
    difficulty: 1,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W3D5-P",
    difficulty: 2,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W4D2-1",
    difficulty: 1,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W4D2-2",
    difficulty: 1,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W4D2-3",
    difficulty: 1,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W4D2-4",
    difficulty: 1,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W4D3-1",
    difficulty: 1,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W4D3-2",
    difficulty: 1,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W4D3-3",
    difficulty: 1,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W4D3-4",
    difficulty: 1,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W4D3-5",
    difficulty: 1,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W4D3-P",
    difficulty: 1,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W5D4-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Evelyn",
    task: "W5D5-P",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Evelyn",
    task: "W6D1-1",
    difficulty: 5,
    fun: 5,
  },
  {
    name: "Evelyn",
    task: "W6D2-1",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Evelyn",
    task: "W6D2-P",
    difficulty: 5,
    fun: 5,
  },
  {
    name: "Aranka",
    task: "SCRUM",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W1D1-1",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W1D2-1",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W1D2-2",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Aranka",
    task: "W1D2-3",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W1D2-4",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W1D2-5",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Aranka",
    task: "W1D3-1",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Aranka",
    task: "W1D3-2",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W1D3-4",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Aranka",
    task: "W1D3-5",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W1D3-P",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W1D4-1",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Aranka",
    task: "W1D4-P",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W1D5-P",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W2D1-1",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Aranka",
    task: "W2D1-2",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Aranka",
    task: "W2D2-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Aranka",
    task: "W2D2-2",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Aranka",
    task: "W2D2-3",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Aranka",
    task: "W2D3-1",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W2D3-2",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W2D3-3",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W2D4-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Aranka",
    task: "W2D4-2",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W2D4-3",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W2D5-P",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Aranka",
    task: "W3D1-1",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Aranka",
    task: "W3D1-2",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Aranka",
    task: "W3D1-3",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Aranka",
    task: "W3D1-4",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W3D2-1",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W3D2-2",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W3D2-3",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W3D3-1",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Aranka",
    task: "W3D3-2",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W3D3-3",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W3D3-4",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W3D4-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W3D4-2",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Aranka",
    task: "W3D5-P",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W4D2-1",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W4D2-2",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Aranka",
    task: "W4D2-3",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Aranka",
    task: "W4D2-4",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Aranka",
    task: "W4D3-1",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W4D3-2",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Aranka",
    task: "W4D3-3",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W4D3-4",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W4D3-5",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W4D3-P",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Aranka",
    task: "W5D4-1",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Aranka",
    task: "W5D5-P",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Aranka",
    task: "W6D1-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Aranka",
    task: "W6D2-1",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Aranka",
    task: "W6D2-P",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Floris",
    task: "SCRUM",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Floris",
    task: "W1D1-1",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Floris",
    task: "W1D2-1",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W1D2-2",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Floris",
    task: "W1D2-3",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Floris",
    task: "W1D2-4",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Floris",
    task: "W1D2-5",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Floris",
    task: "W1D3-1",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Floris",
    task: "W1D3-2",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Floris",
    task: "W1D3-4",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W1D3-5",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Floris",
    task: "W1D3-P",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W1D4-1",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Floris",
    task: "W1D4-P",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Floris",
    task: "W1D5-P",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Floris",
    task: "W2D1-1",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W2D1-2",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Floris",
    task: "W2D2-1",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Floris",
    task: "W2D2-2",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W2D2-3",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W2D3-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Floris",
    task: "W2D3-2",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W2D3-3",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Floris",
    task: "W2D4-1",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Floris",
    task: "W2D4-2",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Floris",
    task: "W2D4-3",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Floris",
    task: "W2D5-P",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Floris",
    task: "W3D1-1",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Floris",
    task: "W3D1-2",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Floris",
    task: "W3D1-3",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Floris",
    task: "W3D1-4",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Floris",
    task: "W3D2-1",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W3D2-2",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W3D2-3",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W3D3-1",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Floris",
    task: "W3D3-2",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Floris",
    task: "W3D3-3",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Floris",
    task: "W3D3-4",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W3D4-1",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Floris",
    task: "W3D4-2",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W3D5-P",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W4D2-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Floris",
    task: "W4D2-2",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Floris",
    task: "W4D2-3",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Floris",
    task: "W4D2-4",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W4D3-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Floris",
    task: "W4D3-2",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Floris",
    task: "W4D3-3",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W4D3-4",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W4D3-5",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Floris",
    task: "W4D3-P",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W5D4-1",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Floris",
    task: "W5D5-P",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Floris",
    task: "W6D1-1",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Floris",
    task: "W6D2-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Floris",
    task: "W6D2-P",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Hector",
    task: "SCRUM",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Hector",
    task: "W1D1-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Hector",
    task: "W1D2-1",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Hector",
    task: "W1D2-2",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Hector",
    task: "W1D2-3",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Hector",
    task: "W1D2-4",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Hector",
    task: "W1D2-5",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W1D3-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Hector",
    task: "W1D3-2",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Hector",
    task: "W1D3-4",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W1D3-5",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Hector",
    task: "W1D3-P",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W1D4-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W1D4-P",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Hector",
    task: "W1D5-P",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Hector",
    task: "W2D1-1",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Hector",
    task: "W2D1-2",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Hector",
    task: "W2D2-1",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Hector",
    task: "W2D2-2",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Hector",
    task: "W2D2-3",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Hector",
    task: "W2D3-1",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W2D3-2",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Hector",
    task: "W2D3-3",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Hector",
    task: "W2D4-1",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Hector",
    task: "W2D4-2",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W2D4-3",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Hector",
    task: "W2D5-P",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W3D1-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W3D1-2",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Hector",
    task: "W3D1-3",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Hector",
    task: "W3D1-4",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Hector",
    task: "W3D2-1",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Hector",
    task: "W3D2-2",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Hector",
    task: "W3D2-3",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W3D3-1",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Hector",
    task: "W3D3-2",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W3D3-3",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Hector",
    task: "W3D3-4",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W3D4-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Hector",
    task: "W3D4-2",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Hector",
    task: "W3D5-P",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Hector",
    task: "W4D2-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W4D2-2",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W4D2-3",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Hector",
    task: "W4D2-4",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Hector",
    task: "W4D3-1",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Hector",
    task: "W4D3-2",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Hector",
    task: "W4D3-3",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W4D3-4",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Hector",
    task: "W4D3-5",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Hector",
    task: "W4D3-P",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W5D4-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Hector",
    task: "W5D5-P",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W6D1-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Hector",
    task: "W6D2-1",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Hector",
    task: "W6D2-P",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Martina",
    task: "SCRUM",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W1D1-1",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W1D2-1",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Martina",
    task: "W1D2-2",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W1D2-3",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W1D2-4",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Martina",
    task: "W1D2-5",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W1D3-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W1D3-2",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W1D3-4",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Martina",
    task: "W1D3-5",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W1D3-P",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Martina",
    task: "W1D4-1",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Martina",
    task: "W1D4-P",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Martina",
    task: "W1D5-P",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W2D1-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W2D1-2",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Martina",
    task: "W2D2-1",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W2D2-2",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Martina",
    task: "W2D2-3",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W2D3-1",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Martina",
    task: "W2D3-2",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W2D3-3",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Martina",
    task: "W2D4-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W2D4-2",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W2D4-3",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W2D5-P",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W3D1-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W3D1-2",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Martina",
    task: "W3D1-3",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W3D1-4",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Martina",
    task: "W3D2-1",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Martina",
    task: "W3D2-2",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W3D2-3",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W3D3-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W3D3-2",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W3D3-3",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Martina",
    task: "W3D3-4",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Martina",
    task: "W3D4-1",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W3D4-2",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W3D5-P",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Martina",
    task: "W4D2-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W4D2-2",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Martina",
    task: "W4D2-3",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W4D2-4",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W4D3-1",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W4D3-2",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Martina",
    task: "W4D3-3",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W4D3-4",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W4D3-5",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Martina",
    task: "W4D3-P",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W5D4-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W5D5-P",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W6D1-1",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Martina",
    task: "W6D2-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Martina",
    task: "W6D2-P",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Maurits",
    task: "SCRUM",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Maurits",
    task: "W1D1-1",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W1D2-1",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Maurits",
    task: "W1D2-2",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Maurits",
    task: "W1D2-3",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Maurits",
    task: "W1D2-4",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W1D2-5",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W1D3-1",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Maurits",
    task: "W1D3-2",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Maurits",
    task: "W1D3-4",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Maurits",
    task: "W1D3-5",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W1D3-P",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W1D4-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Maurits",
    task: "W1D4-P",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W1D5-P",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Maurits",
    task: "W2D1-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W2D1-2",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W2D2-1",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Maurits",
    task: "W2D2-2",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W2D2-3",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Maurits",
    task: "W2D3-1",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Maurits",
    task: "W2D3-2",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W2D3-3",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W2D4-1",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W2D4-2",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Maurits",
    task: "W2D4-3",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W2D5-P",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W3D1-1",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Maurits",
    task: "W3D1-2",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W3D1-3",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Maurits",
    task: "W3D1-4",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Maurits",
    task: "W3D2-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Maurits",
    task: "W3D2-2",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W3D2-3",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W3D3-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W3D3-2",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W3D3-3",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W3D3-4",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W3D4-1",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Maurits",
    task: "W3D4-2",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W3D5-P",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Maurits",
    task: "W4D2-1",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W4D2-2",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Maurits",
    task: "W4D2-3",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W4D2-4",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W4D3-1",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W4D3-2",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Maurits",
    task: "W4D3-3",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Maurits",
    task: "W4D3-4",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W4D3-5",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Maurits",
    task: "W4D3-P",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W5D4-1",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W5D5-P",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Maurits",
    task: "W6D1-1",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Maurits",
    task: "W6D2-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Maurits",
    task: "W6D2-P",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Rahima",
    task: "SCRUM",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W1D1-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W1D2-1",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W1D2-2",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Rahima",
    task: "W1D2-3",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Rahima",
    task: "W1D2-4",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Rahima",
    task: "W1D2-5",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Rahima",
    task: "W1D3-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Rahima",
    task: "W1D3-2",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W1D3-4",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Rahima",
    task: "W1D3-5",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Rahima",
    task: "W1D3-P",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Rahima",
    task: "W1D4-1",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Rahima",
    task: "W1D4-P",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W1D5-P",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Rahima",
    task: "W2D1-1",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Rahima",
    task: "W2D1-2",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Rahima",
    task: "W2D2-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Rahima",
    task: "W2D2-2",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Rahima",
    task: "W2D2-3",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Rahima",
    task: "W2D3-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Rahima",
    task: "W2D3-2",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W2D3-3",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Rahima",
    task: "W2D4-1",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W2D4-2",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W2D4-3",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Rahima",
    task: "W2D5-P",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Rahima",
    task: "W3D1-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Rahima",
    task: "W3D1-2",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Rahima",
    task: "W3D1-3",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Rahima",
    task: "W3D1-4",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W3D2-1",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Rahima",
    task: "W3D2-2",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W3D2-3",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Rahima",
    task: "W3D3-1",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Rahima",
    task: "W3D3-2",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W3D3-3",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W3D3-4",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Rahima",
    task: "W3D4-1",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Rahima",
    task: "W3D4-2",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Rahima",
    task: "W3D5-P",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W4D2-1",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W4D2-2",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Rahima",
    task: "W4D2-3",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Rahima",
    task: "W4D2-4",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Rahima",
    task: "W4D3-1",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Rahima",
    task: "W4D3-2",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Rahima",
    task: "W4D3-3",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Rahima",
    task: "W4D3-4",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Rahima",
    task: "W4D3-5",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Rahima",
    task: "W4D3-P",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Rahima",
    task: "W5D4-1",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Rahima",
    task: "W5D5-P",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Rahima",
    task: "W6D1-1",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W6D2-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Rahima",
    task: "W6D2-P",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Sandra",
    task: "SCRUM",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Sandra",
    task: "W1D1-1",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W1D2-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W1D2-2",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Sandra",
    task: "W1D2-3",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W1D2-4",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Sandra",
    task: "W1D2-5",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W1D3-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Sandra",
    task: "W1D3-2",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Sandra",
    task: "W1D3-4",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W1D3-5",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W1D3-P",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W1D4-1",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Sandra",
    task: "W1D4-P",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W1D5-P",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W2D1-1",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Sandra",
    task: "W2D1-2",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W2D2-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W2D2-2",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W2D2-3",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W2D3-1",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Sandra",
    task: "W2D3-2",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Sandra",
    task: "W2D3-3",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Sandra",
    task: "W2D4-1",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W2D4-2",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W2D4-3",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Sandra",
    task: "W2D5-P",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W3D1-1",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W3D1-2",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W3D1-3",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W3D1-4",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Sandra",
    task: "W3D2-1",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W3D2-2",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W3D2-3",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Sandra",
    task: "W3D3-1",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Sandra",
    task: "W3D3-2",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Sandra",
    task: "W3D3-3",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W3D3-4",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Sandra",
    task: "W3D4-1",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W3D4-2",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Sandra",
    task: "W3D5-P",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Sandra",
    task: "W4D2-1",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W4D2-2",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Sandra",
    task: "W4D2-3",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W4D2-4",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W4D3-1",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Sandra",
    task: "W4D3-2",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W4D3-3",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W4D3-4",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W4D3-5",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W4D3-P",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W5D4-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Sandra",
    task: "W5D5-P",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Sandra",
    task: "W6D1-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Sandra",
    task: "W6D2-1",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Sandra",
    task: "W6D2-P",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Wietske",
    task: "SCRUM",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Wietske",
    task: "W1D1-1",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Wietske",
    task: "W1D2-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W1D2-2",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Wietske",
    task: "W1D2-3",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Wietske",
    task: "W1D2-4",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Wietske",
    task: "W1D2-5",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W1D3-1",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Wietske",
    task: "W1D3-2",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W1D3-4",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Wietske",
    task: "W1D3-5",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W1D3-P",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W1D4-1",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W1D4-P",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Wietske",
    task: "W1D5-P",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Wietske",
    task: "W2D1-1",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Wietske",
    task: "W2D1-2",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Wietske",
    task: "W2D2-1",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Wietske",
    task: "W2D2-2",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W2D2-3",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W2D3-1",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Wietske",
    task: "W2D3-2",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Wietske",
    task: "W2D3-3",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Wietske",
    task: "W2D4-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Wietske",
    task: "W2D4-2",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W2D4-3",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Wietske",
    task: "W2D5-P",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Wietske",
    task: "W3D1-1",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Wietske",
    task: "W3D1-2",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W3D1-3",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Wietske",
    task: "W3D1-4",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W3D2-1",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Wietske",
    task: "W3D2-2",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Wietske",
    task: "W3D2-3",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W3D3-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W3D3-2",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Wietske",
    task: "W3D3-3",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Wietske",
    task: "W3D3-4",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W3D4-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W3D4-2",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Wietske",
    task: "W3D5-P",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W4D2-1",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Wietske",
    task: "W4D2-2",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W4D2-3",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Wietske",
    task: "W4D2-4",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Wietske",
    task: "W4D3-1",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Wietske",
    task: "W4D3-2",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Wietske",
    task: "W4D3-3",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W4D3-4",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Wietske",
    task: "W4D3-5",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Wietske",
    task: "W4D3-P",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Wietske",
    task: "W5D4-1",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Wietske",
    task: "W5D5-P",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Wietske",
    task: "W6D1-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Wietske",
    task: "W6D2-1",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Wietske",
    task: "W6D2-P",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Storm",
    task: "SCRUM",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W1D1-1",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Storm",
    task: "W1D2-1",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Storm",
    task: "W1D2-2",
    difficulty: 1,
    fun: 3,
  },
  {
    name: "Storm",
    task: "W1D2-3",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Storm",
    task: "W1D2-4",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Storm",
    task: "W1D2-5",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Storm",
    task: "W1D3-1",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Storm",
    task: "W1D3-2",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W1D3-4",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W1D3-5",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Storm",
    task: "W1D3-P",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Storm",
    task: "W1D4-1",
    difficulty: 4,
    fun: 2,
  },
  {
    name: "Storm",
    task: "W1D4-P",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Storm",
    task: "W1D5-P",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Storm",
    task: "W2D1-1",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Storm",
    task: "W2D1-2",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Storm",
    task: "W2D2-1",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Storm",
    task: "W2D2-2",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W2D2-3",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W2D3-1",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Storm",
    task: "W2D3-2",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Storm",
    task: "W2D3-3",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Storm",
    task: "W2D4-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Storm",
    task: "W2D4-2",
    difficulty: 4,
    fun: 3,
  },
  {
    name: "Storm",
    task: "W2D4-3",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W2D5-P",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W3D1-1",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W3D1-2",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Storm",
    task: "W3D1-3",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Storm",
    task: "W3D1-4",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Storm",
    task: "W3D2-1",
    difficulty: 1,
    fun: 4,
  },
  {
    name: "Storm",
    task: "W3D2-2",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Storm",
    task: "W3D2-3",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Storm",
    task: "W3D3-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Storm",
    task: "W3D3-2",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Storm",
    task: "W3D3-3",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W3D3-4",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W3D4-1",
    difficulty: 2,
    fun: 4,
  },
  {
    name: "Storm",
    task: "W3D4-2",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Storm",
    task: "W3D5-P",
    difficulty: 3,
    fun: 2,
  },
  {
    name: "Storm",
    task: "W4D2-1",
    difficulty: 2,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W4D2-2",
    difficulty: 3,
    fun: 3,
  },
  {
    name: "Storm",
    task: "W4D2-3",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Storm",
    task: "W4D2-4",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Storm",
    task: "W4D3-1",
    difficulty: 3,
    fun: 4,
  },
  {
    name: "Storm",
    task: "W4D3-2",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Storm",
    task: "W4D3-3",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W4D3-4",
    difficulty: 3,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W4D3-5",
    difficulty: 2,
    fun: 3,
  },
  {
    name: "Storm",
    task: "W4D3-P",
    difficulty: 4,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W5D4-1",
    difficulty: 2,
    fun: 2,
  },
  {
    name: "Storm",
    task: "W5D5-P",
    difficulty: 1,
    fun: 2,
  },
  {
    name: "Storm",
    task: "W6D1-1",
    difficulty: 4,
    fun: 4,
  },
  {
    name: "Storm",
    task: "W6D2-1",
    difficulty: 1,
    fun: 1,
  },
  {
    name: "Storm",
    task: "W6D2-P",
    difficulty: 3,
    fun: 3,
  },
];

export default studentData;
